import BlockRenderer from "@/cms/BlockRenderer";
import { useSiteContent } from "@/cms/useSiteContent";

export default function AboutUs() {
  const { blocks } = useSiteContent("about-us");

  return (
    <div className="min-h-screen bg-[#0B2421]">
      <BlockRenderer blocks={blocks} />
    </div>
  );
}
